import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HERO_IMAGE } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  const trustItems = [
    { icon: "ri-verified-badge-line", label: t("trust.1") },
    { icon: "ri-time-line", label: t("trust.2") },
    { icon: "ri-global-line", label: t("trust.3") },
    { icon: "ri-shield-check-line", label: t("trust.4") },
  ];

  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[560px] md:h-[640px] w-full">
        <img
          src={HERO_IMAGE}
          alt="USFans Spreadsheet resources"
          title="USFans Spreadsheet resources"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/55"></div>

        <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col items-center justify-center px-4 md:px-6 text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm font-medium text-background-50">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-sparkling-line"></i>
            </span>
            {t("hero.badge")}
          </span>

          <h1 className="mt-6 max-w-4xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            {t("hero.title")}
          </h1>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
            {t("hero.subtitle")}
          </p>

          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
            <a
              href="#categories"
              className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              {t("hero.ctaPrimary")}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-s-line"></i>
              </span>
            </a>
            <Link
              to="/guide/what-is"
              className="inline-flex items-center gap-2 rounded-full border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/20 whitespace-nowrap cursor-pointer"
            >
              {t("hero.ctaSecondary")}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          <p className="mt-6 max-w-xl text-sm text-background-100/90">
            {t("hero.support")}
          </p>
        </div>
      </div>

      <div className="border-b border-background-200 bg-background-50">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-4 px-4 py-5 md:grid-cols-4 md:px-6">
          {trustItems.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-2.5 text-sm font-medium text-foreground-700"
            >
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className={item.icon}></i>
              </span>
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}